import { ServerTeamOrder } from '@/api/type-response'
import { ServerTeamInfo, ServerTeamUser, ServerTeamVolume } from '@/api/type-server'
import { TeamRole } from '@/consts/team'

export interface TeamOrder {
  id: number
  itemID: number
  renewPrice: number
  autoRenewal: boolean
}

export class Team {
  id: number
  resID: string
  ownerID: number
  name: string
  domainName: string
  introduction: string
  createTime: Date
  memberLimit: number
  adminLimit: number
  user: TeamUser
  volume: ServerTeamVolume | null
  orderDeadline: Date | null
  planName: string | null
  order: TeamOrder | null

  constructor(props: {
    team: ServerTeamInfo
    user: ServerTeamUser
    volumes: ServerTeamVolume | null
    order: ServerTeamOrder | null
  }) {
    const { team, user, volumes, order } = props

    this.id = team.id
    this.resID = team.desc.resID
    this.ownerID = team.ownerID
    this.name = team.name
    this.domainName = team.desc.domainName
    this.introduction = team.introduction
    this.createTime = new Date(team.createTime.seconds * 1000)
    this.memberLimit = team.profile.limit.membersNumLimit
    this.adminLimit = team.profile.limit.adminsNumLimit
    this.user = new TeamUser(user)
    this.volume = volumes
    this.orderDeadline = order?.deadlineTime ? new Date(order.deadlineTime.seconds * 1000) : null
    this.planName = order?.item?.desc?.team?.name ?? null
    this.order = order
      ? {
          id: order.id,
          itemID: order.item.id,
          renewPrice: order.renewPrice.priceCent,
          autoRenewal: order.autoRenewal,
        }
      : null
  }

  get isOwner() {
    return this.user.role === TeamRole.Owner
  }

  get isAdmin() {
    return this.user.role === TeamRole.Admin || this.user.role === TeamRole.Owner
  }

  get isExpired() {
    return this.orderDeadline !== null && this.orderDeadline < new Date()
  }
}

export class TeamUser {
  name: string
  role: TeamRole
  nickname: string
  note: string

  constructor(props: ServerTeamUser) {
    this.name = props.name
    this.role = props.role
    this.nickname = props.nickname
    this.note = props.note
  }
}
